import * as React from 'react';
import { Icon, Text } from '@grandvisionhq/iris-ui';

const AssetLink = ({ asset  })=>{
    var ref;
    const source = (ref = asset.sources[0]) === null || ref === void 0 ? void 0 : ref.uri;
    if (!source) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("li", {
        className: "asset-link"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "asset-link__icon-wrapper"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "file-pdf",
        fallBackProps: {
            className: 'asset-link__icon'
        },
        variant: "Note",
        "aria-label": "file-pdf",
        width: 24,
        height: 24
    })), /*#__PURE__*/ React.createElement("div", {
        className: "asset-link__text-wrapper"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        spacings: [
            'mb-0'
        ]
    }, /*#__PURE__*/ React.createElement("a", {
        href: encodeURI(source).concat('?fm=pdf'),
        target: "_blank",
        rel: "noreferrer"
    }, asset.name))));
};

export { AssetLink };
//# sourceMappingURL=AssetLink.js.map
